import { render, staticRenderFns } from "./PdfPage.vue?vue&type=template&id=548ecbfa&scoped=true&"
import script from "./PdfPage.vue?vue&type=script&lang=js&"
export * from "./PdfPage.vue?vue&type=script&lang=js&"
import style0 from "./PdfPage.vue?vue&type=style&index=0&id=548ecbfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ecbfa",
  null
  
)

export default component.exports